import React from 'react';

import { AvatarGroupProps } from './AvatarGroup';
import ExcessAvatarLabel from './ExcessAvatarLabel';

type ReactChildren = (React.ReactChild | React.ReactFragment | React.ReactPortal)[];

export default function getChildAvatars(avatars: ReactChildren, props: AvatarGroupProps): React.ReactElement[] {
  const { staggered, size } = props;

  const max = staggered ? 2 : 4;

  if (avatars.length > max) {
    const filteredAvatars = avatars.slice(0, max - 1);
    const excessCount = avatars.length - filteredAvatars.length;

    return [
      ...getAvatarsWithProps(filteredAvatars, props),
      <ExcessAvatarLabel count={excessCount} key="excess-label" size={size} staggered={staggered} />
    ];
  }

  if (avatars.length === max) {
    const filteredAvatars = avatars.slice(0, max);
    return getAvatarsWithProps(filteredAvatars, props);
  }

  return getAvatarsWithProps(avatars, props);
}

function getAvatarsWithProps(avatars: React.ReactNode, props: AvatarGroupProps) {
  const { size } = props;

  return React.Children.map(avatars, (childAvatar: React.ReactElement, index: number) =>
    React.cloneElement(childAvatar, {
      ...childAvatar.props,
      size,
      marginLeft: props.staggered && index > 0 && '0.85em',
      marginTop: props.staggered && index > 0 && '-1.15em'
    })
  ) as React.ReactElement[];
}
